import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import Layout from '../../components/layouts/Main';
import config from '../../config';
import { toast } from 'react-toastify';
import VendorTable from '../../components/vendors/VendorTable';
import VendorModal from '../../components/vendors/VendorModal';
import { PulseLoader } from "react-spinners";
// import PermissionGate from '../../components/common/PermissionGate';
import { useHasPermission, PERMISSIONS } from '../../utils/permissions';

function VendorPage() {
  const [vendors, setVendors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Permission checks
  const canViewVendors = useHasPermission(PERMISSIONS.VIEW_VENDORS);
  const canAddVendors = useHasPermission(PERMISSIONS.ADD_VENDORS);
  const canEditVendors = useHasPermission(PERMISSIONS.EDIT_VENDORS);
  const canDeleteVendors = useHasPermission(PERMISSIONS.DELETE_VENDORS);

  const fetchVendors = async () => {
    if (!canViewVendors) {
      toast.error("You don't have permission to view vendors");
      return;
    }

    setIsLoading(true);
    try {
      const res = await axios.get(`${config.API_BASE_URL}/vendors`);
      setVendors(res.data);
    } catch (err) {
      console.error("Error fetching vendors", err);
      toast.error("Failed to load vendors");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors();
    if (sessionStorage.getItem('vendorAdded')) {
      toast.success('Vendor added successfully!');
      sessionStorage.removeItem('vendorAdded');
    }
  }, [canViewVendors]);
  // }, [canViewVendors]);

  const handleVendorAdded = () => {
    if (!canAddVendors) {
      toast.error("You don't have permission to add vendors");
      return;
    }
    window.location.reload();
  };

  // If user can't view vendors, show permission denied
  if (!canViewVendors) {
    return (
      <Layout>
        <nav aria-label="breadcrumb" className="mb-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
            <li className="breadcrumb-item active">Vendors</li>
          </ol>
        </nav>
        <Alert variant="danger" className="d-flex align-items-center">
          <i className="fas fa-exclamation-triangle me-2"></i>
          <div>
            <strong>Access Denied</strong>
            <p className="mb-0">You don't have permission to view vendors. Contact your administrator for access.</p>
          </div>
        </Alert>
      </Layout>
    );
  }

  return (
    <Layout>
      <nav aria-label="breadcrumb" className="mb-3">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
          <li className="breadcrumb-item active">Vendors</li>
        </ol>
      </nav>

      <Row className="mb-4">
        <Col>
          <h2>Vendors</h2>
          <small className="text-muted">
            {canEditVendors ? "View and manage" : "View"} vendors
            {!canAddVendors && !canEditVendors && !canDeleteVendors && " (read-only)"}
          </small>
        </Col>
        <Col className="text-end">
          {/* <PermissionGate
            require={PERMISSIONS.ADD_VENDORS}
            fallback={
              <Button variant="outline-primary" disabled title="You don't have permission to add vendors">
                <i className="fas fa-plus me-2" /> Add Vendor
              </Button>
            }
          > */}
          {canAddVendors && (
            <Button onClick={() => setShowModal(true)}>
              <i className="fas fa-plus me-2" /> Add Vendor
            </Button>
          )}
          {/* </PermissionGate> */}
        </Col>
      </Row>

      {isLoading ? (
        <PulseLoader
          color="#014b7cbb"
          size={9}
        />
      ) : (
        <VendorTable 
          vendors={vendors} 
          canEdit={canEditVendors}
          canDelete={canDeleteVendors}
          canView={canViewVendors}
        />
      )}

      {canAddVendors && (
        <VendorModal
          show={showModal}
          onHide={() => setShowModal(false)}
          onVendorAdded={handleVendorAdded}
        />
      )}
    </Layout>
  );
}

export default VendorPage;
